import type { ElementType, ReactNode } from "react";
import styled from "styled-components";

const CaptionRoot = styled.div`
  box-sizing: border-box;
  display: flex;
  align-self: stretch;
  max-width: 100%;
  min-width: 0;
  padding: var(--c6-media-caption-padding, 0);
  flex-direction: column;
  gap: 0.1rem;
  background-color: var(--c6-media-caption-surface, transparent);
  border-radius: var(--c6-media-caption-radius, 0);
`;

const Title = styled.span`
  min-width: 0;
  overflow: hidden;
  color: var(--c6-media-caption-color, ${({ theme }) => theme.color.text.default});
  font-size: ${({ theme }) => theme.typography.size.caption};
  font-weight: ${({ theme }) => theme.typography.weight.medium};
  line-height: ${({ theme }) => theme.typography.lineHeight.tight};
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Subtitle = styled.span`
  min-width: 0;
  overflow: hidden;
  color: var(--c6-media-caption-subtle-color, ${({ theme }) => theme.color.text.subtle});
  font-size: ${({ theme }) => theme.typography.size.caption};
  font-weight: ${({ theme }) => theme.typography.weight.regular};
  line-height: ${({ theme }) => theme.typography.lineHeight.tight};
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export interface VideoCaptionProps {
  label?: ReactNode;
  subLabel?: ReactNode;
  /** false면 렌더하지 않는다(showLabel 게이트). 기본 true. */
  show?: boolean;
  /** 래퍼 엘리먼트. VideoSurface는 figure 안이라 figcaption, 그리드 타일은 div. 기본 div. */
  as?: ElementType;
  className?: string;
}

/**
 * VideoSurface와 SyncedVideoGrid 타일이 공유하는 캡션(제목 + 보조 라벨). 두 곳에 복붙돼 있던
 * 동일한 styled 캡션을 한 곳으로 모았다. zoom 레이아웃은 호출부가 정한다 — 캡션은 줌 래퍼
 * 밖에 두고 프레임만 감싸면 된다.
 */
export function VideoCaption({ label, subLabel, show = true, as, className }: VideoCaptionProps) {
  if (!show || (!label && !subLabel)) return null;

  return (
    <CaptionRoot as={as} className={className}>
      {label ? <Title>{label}</Title> : null}
      {subLabel ? <Subtitle>{subLabel}</Subtitle> : null}
    </CaptionRoot>
  );
}
